export const ILocation = {
  id: 9,
  uber_location_name: 'TechSuite',
  uber_location_id: '386cd958-3fd6-4b98-8f8e-2cba89181ee7',
  uber_status: 'ACTIVE',
  store_id: 145,
}

export const ISetLocation = {
  id: 9,
  store_id: 122,
  location_name: 'TechSuite',
  location_channel_id: '386cd958-3fd6-4b98-8f8e-2cba89181ee7',
  status: 'ACTIVE',
  json_data: {
    id: '386cd958-3fd6-4b98-8f8e-2cba89181ee7',
    name: 'TechSuite',
    contact: {
      email: 'reza@techsuite.ai',
      name: 'Tech Suite',
      phone_number: '+13357896467',
    },
    location: {
      latitude: '51.49344',
      longitude: '-0.21966',
      street_address_line_one: '174 Hammersmith Road',
      city: 'London',
      country: 'GB',
      postal_code: 'W6 7JP',
    },
    timezone: 'Europe/London',
    prep_times: {
      default_value: 900,
      rules: null,
    },
    onboarding_status: 'ACTIVE',
    holiday_hours: null,
    internal_contact_emails: null,
    partner_identifiers: null,
    merchant_contact_emails: null,
  },
  partner_id: 5,
  last_user_id: 0,
  created_at: '2024-05-14T13:24:41.127Z',
  updated_at: '2024-05-14T13:24:41.127Z',
  is_archive: false,
  archived_at: null,
}
